import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"
import { digitalManagerApi } from "../services/api"

export function useAccessRequestCheck() {
  const queryClient = useQueryClient()

  const { data: existAccessRequest = false, isLoading: isLoadingResponse } = useQuery({
    queryKey: ["accessRequestCheck"],
    queryFn: () =>
      digitalManagerApi
        .get<boolean>("/backOfficeAccess/requests/check")
        .then((r) => r.data),
  })

  const setAccessRequest = useCallback(
    () => queryClient.setQueryData(["accessRequestCheck"], true),
    [queryClient]
  )

  return {
    existAccessRequest,
    setAccessRequest,
    isLoadingResponse,
  }
}
